// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Get the details element
  const detailsElement = document.querySelector('details.uom-2035-contents');

  if (!detailsElement) {
    return;
  }

  // Function to check if window width is less than 799px
  function isNarrowScreen() {
    const isNarrow = window.innerWidth < 799;
    return isNarrow;
  }

  function closeDetails() {
    detailsElement.open = false;
  }

  function openDetails() {
    detailsElement.open = true;
  }

  // Handle window resize with debouncing
  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (isNarrowScreen()) {
        closeDetails();
      } else {
        // Window is wider than 799px, open the details
        openDetails();
      }
    }, 100);
  }

  // Handle link clicks inside the details element
  function handleLinkClick(event) {
    // Check if the clicked element is a link or inside a link
    const link = event.target.closest('a');
    if (link && isNarrowScreen()) {
      closeDetails();
    }
  }

  // Add event listeners
  window.addEventListener('resize', handleResize);
  detailsElement.addEventListener('click', handleLinkClick);

  // Initial check when page loads
  if (isNarrowScreen() && detailsElement.open) {
    closeDetails();
  }
});
